import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import authReducers from './authReducers';
import miscReducers from './miscReducers';
import analyticsReducers from './analyticsReducers';
import itemReducers from './itemReducers';
import payoutReducers from './payoutReducers';
import preferencesReducers from './preferencesReduces';
import salesReducers from './salesReducers';
import employeeReducers from './employeeReducers';
import crmReducers from './crmReducers';

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducers,
    misc: miscReducers,
    item: itemReducers,
    salesReport: salesReducers,
    payout: payoutReducers,
    preferences: preferencesReducers,
    analytics: analyticsReducers,
    employees: employeeReducers,
    crm: crmReducers,
  });

export default reducers;
